/**
 * ActivityDefinition schemas — notification templates.
 *
 * Sources: notification-template.medplum.ts,
 * PRD_NOTIFICATIONS.md
 */
import { z } from 'zod';

/** ActivityDefinition.status values. */
export const activityDefinitionStatusValues = ['draft', 'active', 'retired', 'unknown'] as const;

/** Notification delivery channel. */
export const notificationChannelValues = ['email', 'in-app', 'sms'] as const;

/**
 * Create / update a notification template (ActivityDefinition).
 */
export const notificationTemplateSchema = z.object({
  name: z.string().trim().min(1, 'Template name is required'),
  title: z.string().trim().min(1, 'Template title is required'),
  status: z.enum(activityDefinitionStatusValues).default('draft'),
  channel: z.enum(notificationChannelValues).optional(),
  subjectTemplate: z.string().optional(),
  bodyTemplate: z.string().min(1, 'Email body is required'),
  description: z.string().optional(),
});

export type NotificationTemplateInput = z.infer<typeof notificationTemplateSchema>;
